import {
    IdCardWrapper,
    TitleAndCommandsWrapper,
    TitlesWrapper,
    CommandsWrapper,
    SaveChangesExitWrapper,
    TextualDetailsWrapper,
    SectionTitle,
    SubMenusWrapper,
    SaveChangesButton,
    DiscardChangesButton,
    IdCardTitle,
    ModuleTitle,
    DescriptionAndMainImageWrapper,
    SectionTitleEl,
    DescriptionAndScopeWrapper,
    CharacteristicInput,
    CharacteristicsAndModulesWrapper,
    CharacteristicsSectionWrapper,
    CharacteristicsWrapper,
    CharacteristicTitle,
    CharacteristicUnit,
    CharacteristicWrapper,
    ImagesWrapper,
    ImageWrapper,
    ModuleImage,
    ModuleName,
    ModuleNameWrapper,
    ModulesWrapper,
    ModuleTsCode,
    ModuleWrapper,
} from './styles';

import DescriptionEdit from '../DescriptionEdit';
import SubMenuItem from '../SubMenuItem';
import Dropdown from '../Dropdown';
import useObjectElements from '../../hooks/useObjectElements';
import ModalView from '../ModalView';
import Loader from '../Loader';
import MainImageEdit from '../MainImageEdit';
import ImageViewer from '../ImageViewer';
import DocumentsEdit from '../DocumentsEdit';

import { defaultIdCard } from '../../config/defaultIdCard';
import useCreateProjectIdCard from '../../hooks/useCreateProjectIdCard';
import { createRef, useState } from 'react';
import useDeleteImage from '../../hooks/useDeleteImage';
import { useIdCatalogSearch } from '../SideMenuSearchLane/context';
import { ImageContext } from '../../context/ImageContext';
import ValidationInput from '../ValidationInput';
import { toast } from 'react-toastify';
import { Prompt } from 'react-router-dom';
import {MODAL_ACTION, CONTRACT_TYPE_OPTIONS, MOORING_SYSTEM_OPTIONS} from '../../config/enums';
import useFindProject from '../../hooks/useFindProject';

const ProjectIdCardCreate = ({ onModalClose, projectId }) => {
    const {
        object: idCardNewData,
        setObjectValue: setNewDataField,
        setMultipleObjectValues: setMultipleNewFields,
    } = useObjectElements({ initialValues: { ...defaultIdCard } });
    const [idCardImages, setIdCardImages] = useState(defaultIdCard.images);
    const { removeCatalogItem, addCatalogItem, searchFilter,
        updateSearchFilterField, } = useIdCatalogSearch();
    const { deleteImage } = useDeleteImage();
    const { project, isLoading: isProjectLoading } = useFindProject(projectId);
    if (project) {
        idCardNewData.projectId = projectId;
        idCardNewData.projectNr = project.number;
        idCardNewData.projectName = project.name;
        idCardNewData.projectClient = project.client;
        idCardNewData.projectLocation = project.location;
    }
    const { createProjectIdCard, isLoading: isLoadingCreate } = useCreateProjectIdCard({ onModalClose });

    const onModalLeaveClick = (locationPath) => {
        setModalProp(MODAL_ACTION.IS_OPEN, false);
        deleteAllUnusedUploadedImages();
    };

    const onModalDiscardClick = () => {
        setModalProp(MODAL_ACTION.IS_OPEN, false);
        setModalProp(MODAL_ACTION.ON_RIGHT_BTN, () => onModalLeaveClick());
    };

    const {
        object: modalData,
        setObjectValue: setModalProp,
        setObject: setModalData,
    } = useObjectElements({
        initialValues: {
            modalIsOpen: false,
            modalTitle: 'Are you sure?',
            leftBtnTitle: 'NO',
            rightBtnTitle: 'YES',
            modalDescription: "Are you sure you don't want to save the ID Card?",
            onCloseModal: onModalDiscardClick,
            onBtnLeftClick: onModalDiscardClick,
            onBtnRightClick: () => onModalLeaveClick(),
        },
    });

    const onPageDiscardButton = () => {
        setModalProp(MODAL_ACTION.IS_OPEN, true);
    };

    const deleteAllUnusedUploadedImages = () => {
        // check for images that were uploaded but the changes weren't saved
        idCardImages.forEach((image) => {
            if (image.imageId) {
                deleteImage(image.imageId);
            }
        });
    };

    const validationFunc = (name, value) => {
        return value?.length > 1;
    };

    const validationFuncNumeric = (field, value) => {
        return (!value || (value && !isNaN(value)));
    };

    // mandatory fields refs
    const descriptionRef = createRef();

    const onSaveCreatedProjectIdCard = () => {
        if (!validationFunc('description', idCardNewData.description)) {
            descriptionRef.current.scrollIntoView();
            descriptionRef.current.focus();
            toast.error(`Please fill in a description`, {
                position: toast.POSITION.TOP_LEFT,
            });
            return;
        }
        const newIdCard = { ...idCardNewData, images: idCardImages };
        createProjectIdCard({idCardData: newIdCard, onSuccessCallback: () => updateSearchFilterField('refreshToggle', !searchFilter.refreshToggle)});
    };

    const handleOnLeavePage = (location, action) => {
        if (action === 'POP') {
            return true;
        }
        if (modalData.modalIsOpen) {
            return true;
        }

        setModalData({
            modalIsOpen: true,
            modalTitle: 'Are you sure?',
            leftBtnTitle: 'NO',
            rightBtnTitle: 'YES',
            modalDescription: "Are you sure you don't want to save the ID Card?",
            onCloseModal: onModalDiscardClick,
            onBtnLeftClick: onModalDiscardClick,
            onBtnRightClick: () => onModalLeaveClick(location.pathname),
        });
        return false;
    };

    const onSuccessImageUpload = (resData, imageFile, imageArrIndex) => {
        const updatedImages = [...idCardImages];
        updatedImages[imageArrIndex] = {
            imageId: resData,
            indexNr: imageArrIndex,
            legend: imageFile.name,
        };
        setIdCardImages(updatedImages);
    };

    const onSuccessImageRemove = (resData, imageFile, imageArrIndex) => {
        const updatedImages = [...idCardImages];
        updatedImages[imageArrIndex] = {
            imageId: null,
            indexNr: imageArrIndex,
            legend: '',
        };
        setIdCardImages(updatedImages);
    };

    const shouldSendDeleteImageReq = (imageId) => {
        return !!imageId;
    };

    if (isLoadingCreate) {
        return <Loader />;
    }
    return (
        <ImageContext.Provider
            value={{
                idCardImages,
                setIdCardImages,
                onSuccessImageUpload,
                onSuccessImageRemove,
                shouldSendDeleteImageReq,
            }}>
            <IdCardWrapper>
                <Prompt
                    when={true}
                    message={(location, action) => {
                        return handleOnLeavePage(location, action);
                    }}
                />
                <ModalView
                    isOpen={modalData.modalIsOpen}
                    title={modalData.modalTitle}
                    description={modalData.modalDescription}
                    onCloseBtn={modalData.onCloseModal}
                    onBtnLeftClick={modalData.onBtnLeftClick}
                    onBtnRightClick={modalData.onBtnRightClick}
                    leftBtnTitle={modalData.leftBtnTitle}
                    rightBtnTitle={modalData.rightBtnTitle}
                />
                <TitleAndCommandsWrapper>
                    <TitlesWrapper>
                        <IdCardTitle>
                            <SectionTitleEl>{`${idCardNewData.projectNr ? idCardNewData.projectNr : ''} - ${idCardNewData.projectName ? idCardNewData.projectName : ''}`}</SectionTitleEl>
                        </IdCardTitle>
                        <ModuleTitle>
                            <SectionTitleEl>{`${idCardNewData.projectClient ?? ''}`}</SectionTitleEl>
                        </ModuleTitle>
                        <ModuleTitle>
                            <SectionTitleEl>{`${idCardNewData.projectLocation ?? ''}`}</SectionTitleEl>
                        </ModuleTitle>
                    </TitlesWrapper>
                    <CommandsWrapper>
                        <SaveChangesExitWrapper>
                            <SaveChangesButton
                                title={'Save'}
                                onClick={() => onSaveCreatedProjectIdCard()}
                            />
                        </SaveChangesExitWrapper>
                        <DiscardChangesButton
                            type='transparentBackgroundButton'
                            title='Cancel'
                            onClick={onPageDiscardButton}
                        />
                    </CommandsWrapper>
                </TitleAndCommandsWrapper>

                <TextualDetailsWrapper>
                    <DescriptionAndMainImageWrapper>
                        <DescriptionAndScopeWrapper>
                            <SectionTitle>Description:</SectionTitle>
                            <DescriptionEdit style={{height:'200px',width:'80%'}}
                                             text={idCardNewData.description ?? ''}
                                             onChange={(e) => setNewDataField('description', e.target.value)}
                            />
                            <SectionTitle>SBM scope of work:</SectionTitle>
                            <DescriptionEdit style={{height:'200px',width:'80%'}}
                                             text={idCardNewData.scopeOfWork ?? ''}
                                             onChange={(e) => setNewDataField('scopeOfWork', e.target.value)}
                            />
                        </DescriptionAndScopeWrapper>
                        <MainImageEdit style={{margin:'40px 0px'}}
                                       image={idCardImages[0]}
                                       imageIndex={0}
                                       hideLabel={true}
                        />
                    </DescriptionAndMainImageWrapper>
                </TextualDetailsWrapper>
                <ImagesWrapper>
                    <ImageWrapper>
                        <SectionTitle>General Arrangement:</SectionTitle>
                        <MainImageEdit style={{height:'200px',width:'100%'}}
                                       image={idCardImages[1]}
                                       imageIndex={1}
                                       hideLabel={true}
                        />
                    </ImageWrapper>
                    <ImageWrapper>
                        <SectionTitle>Process Overview:</SectionTitle>
                        <MainImageEdit style={{height:'200px',width:'100%'}}
                                       image={idCardImages[2]}
                                       imageIndex={2}
                                       hideLabel={true}
                        />
                    </ImageWrapper>
                    <ImageWrapper>
                        <SectionTitle>Field layout:</SectionTitle>
                        <MainImageEdit style={{height:'200px',width:'100%'}}
                                       image={idCardImages[3]}
                                       imageIndex={3}
                                       hideLabel={true}
                        />
                    </ImageWrapper>
                </ImagesWrapper>
                <CharacteristicsAndModulesWrapper>
                    <CharacteristicsWrapper>
                        <CharacteristicsSectionWrapper>
                            <SectionTitle>Project characteristics:</SectionTitle>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Contract type:</CharacteristicTitle>
                                <Dropdown
                                    value={idCardNewData.contractType}
                                    options={CONTRACT_TYPE_OPTIONS}
                                    placeholder='Contract type'
                                    onChange={(option) => {
                                        setNewDataField('contractType', option.value);
                                    }}
                                    externalStyles={{container:(styles) => ({
                                            ...styles,
                                            width: '50%',
                                            flex: '3',
                                        })}}
                                />
                                <CharacteristicUnit></CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Contract duration:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Contract duration'
                                    value={idCardNewData.contractDuration ?? ''}
                                    onChange={(e) => setNewDataField('contractDuration', e.target.value)}
                                    name='contractDuration'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Contract duration must be numeric'}
                                />
                                <CharacteristicUnit>year</CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Mooring system:</CharacteristicTitle>
                                <Dropdown
                                    value={idCardNewData.mooringSystem}
                                    options={MOORING_SYSTEM_OPTIONS}
                                    placeholder='Mooring system'
                                    onChange={(option) => {
                                        setNewDataField('mooringSystem', option.value);
                                    }}
                                    externalStyles={{container:(styles) => ({
                                            ...styles,
                                            width: '50%',
                                            flex: '3',
                                        })}}
                                />
                                <CharacteristicUnit></CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Integration yard:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Integration yard'
                                    value={idCardNewData.integrationYard ?? ''}
                                    onChange={(e) => setNewDataField('integrationYard', e.target.value)}
                                    name='integrationYard'
                                    validation={() => true}
                                    errorMsg={''}
                                />
                                <CharacteristicUnit></CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Nr production risers:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Nr production risers'
                                    value={idCardNewData.nrProductionRisers ?? ''}
                                    onChange={(e) => setNewDataField('nrProductionRisers', e.target.value)}
                                    name='nrProductionRisers'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Nr production risers must be numeric'}
                                />
                                <CharacteristicUnit></CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Nr gas risers:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Nr gas risers'
                                    value={idCardNewData.nrGasRisers ?? ''}
                                    onChange={(e) => setNewDataField('nrGasRisers', e.target.value)}
                                    name='nrGasRisers'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Nr gas risers must be numeric'}
                                />
                                <CharacteristicUnit></CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Nr gas export risers:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Nr gas export risers'
                                    value={idCardNewData.nrGasExportRisers ?? ''}
                                    onChange={(e) => setNewDataField('nrGasExportRisers', e.target.value)}
                                    name='nrGasExportRisers'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Nr gas export risers must be numeric'}
                                />
                                <CharacteristicUnit></CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Nr water risers:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Nr water risers'
                                    value={idCardNewData.nrWaterRisers ?? ''}
                                    onChange={(e) => setNewDataField('nrWaterRisers', e.target.value)}
                                    name='nrWaterRisers'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Nr water risers must be numeric'}
                                />
                                <CharacteristicUnit></CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Hull dimensions (LxWxH):</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Hull dimensions'
                                    value={idCardNewData.hullDimensions ?? ''}
                                    onChange={(e) => setNewDataField('hullDimensions', e.target.value)}
                                    name='hullDimensions'
                                    validation={() => true}
                                    errorMsg={''}
                                />
                                <CharacteristicUnit>m</CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Max POB:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Max POB'
                                    value={idCardNewData.maxPob ?? ''}
                                    onChange={(e) => setNewDataField('maxPob', e.target.value)}
                                    name='maxPob'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Max POB must be numeric'}
                                />
                                <CharacteristicUnit></CharacteristicUnit>
                            </CharacteristicWrapper>
                        </CharacteristicsSectionWrapper>
                        <CharacteristicsSectionWrapper>
                            <SectionTitle>Field characteristics:</SectionTitle>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Field name:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Field name'
                                    value={idCardNewData.fieldName ?? ''}
                                    onChange={(e) => setNewDataField('fieldName', e.target.value)}
                                    name='fieldName'
                                    validation={() => true}
                                    errorMsg={''}
                                />
                                <CharacteristicUnit></CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Distance from shore:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Distance from shore'
                                    value={idCardNewData.distanceFromShore ?? ''}
                                    onChange={(e) => setNewDataField('distanceFromShore', e.target.value)}
                                    name='distanceFromShore'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Distance from shore must be numeric'}
                                />
                                <CharacteristicUnit>km</CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Water depth:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Water depth'
                                    value={idCardNewData.waterDepth ?? ''}
                                    onChange={(e) => setNewDataField('waterDepth', e.target.value)}
                                    name='waterDepth'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Water depth must be numeric'}
                                />
                                <CharacteristicUnit>m</CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Field specifics:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Field specifics'
                                    value={idCardNewData.fieldSpecifics ?? ''}
                                    onChange={(e) => setNewDataField('fieldSpecifics', e.target.value)}
                                    name='fieldSpecifics'
                                    validation={() => true}
                                    errorMsg={''}
                                />
                                <CharacteristicUnit></CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Crude oil viscosity:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Crude oil viscosity'
                                    value={idCardNewData.crudeOilViscosity ?? ''}
                                    onChange={(e) => setNewDataField('crudeOilViscosity', e.target.value)}
                                    name='crudeOilViscosity'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Contract duration must be numeric'}
                                />
                                <CharacteristicUnit>°API</CharacteristicUnit>
                            </CharacteristicWrapper>
                        </CharacteristicsSectionWrapper>
                        <CharacteristicsSectionWrapper>
                            <SectionTitle>FPSO characteristics:</SectionTitle>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Gas blanketing:</CharacteristicTitle>
                                <Dropdown
                                    value={idCardNewData.gasBlanketing}
                                    options={[{value:true,label:'Yes'},{value:false,label:'No'}]}
                                    placeholder='Gas blanketing'
                                    onChange={(option) => {
                                        setNewDataField('gasBlanketing', option.value);
                                    }}
                                    externalStyles={{container:(styles) => ({
                                            ...styles,
                                            width: '50%',
                                            flex: '3',
                                        })}}
                                />
                                <CharacteristicUnit></CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Storage capacity:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Storage capacity'
                                    value={idCardNewData.storageCapacity ?? ''}
                                    onChange={(e) => setNewDataField('storageCapacity', e.target.value)}
                                    name='storageCapacity'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Storage capacity must be numeric'}
                                />
                                <CharacteristicUnit>m3</CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Oil production:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Oil production'
                                    value={idCardNewData.oilProduction ?? ''}
                                    onChange={(e) => setNewDataField('oilProduction', e.target.value)}
                                    name='oilProduction'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Oil production must be numeric'}
                                />
                                <CharacteristicUnit>bpd</CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Water production:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Water production'
                                    value={idCardNewData.waterProduction ?? ''}
                                    onChange={(e) => setNewDataField('waterProduction', e.target.value)}
                                    name='waterProduction'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Water production must be numeric'}
                                />
                                <CharacteristicUnit>bpd</CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Total liquid:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Total liquid'
                                    value={idCardNewData.totalLiquid ?? ''}
                                    onChange={(e) => setNewDataField('totalLiquid', e.target.value)}
                                    name='totalLiquid'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Total liquid must be numeric'}
                                />
                                <CharacteristicUnit>bpd</CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Gas production:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Gas production'
                                    value={idCardNewData.gasProduction ?? ''}
                                    onChange={(e) => setNewDataField('gasProduction', e.target.value)}
                                    name='gasProduction'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Gas production must be numeric'}
                                />
                                <CharacteristicUnit>MM scfd</CharacteristicUnit>
                            </CharacteristicWrapper>
                        </CharacteristicsSectionWrapper>
                    </CharacteristicsWrapper>
                    <ModulesWrapper>
                        <SectionTitle>Modules:</SectionTitle>
                        {idCardNewData.modules && idCardNewData.modules.map(module =>
                            <ModuleWrapper onClick={() => addCatalogItem(module.tagId, false)} key={module.tagId}>
                                <ModuleImage>
                                    <ImageViewer
                                        imageId={module.imageId}
                                        fullscreen={false}
                                        defaultLoaderSize={35}
                                        containerStyle={{
                                            width: '100%',
                                            height: '100%',
                                        }}
                                    />
                                </ModuleImage>
                                <ModuleNameWrapper>
                                    <ModuleTsCode>{module.tsCode}</ModuleTsCode>
                                    <ModuleName>{module.name}</ModuleName>
                                </ModuleNameWrapper>
                            </ModuleWrapper>
                        )}
                    </ModulesWrapper>
                </CharacteristicsAndModulesWrapper>
                <SubMenusWrapper>
                    <SubMenuItem
                        title={'Documentation List'}
                        component={
                            <DocumentsEdit
                                documents={idCardNewData.documents}
                                setNewDataField={setNewDataField}
                            />}
                    />
                </SubMenusWrapper>
            </IdCardWrapper>
        </ImageContext.Provider>
    );
};

export default ProjectIdCardCreate;
